import React from "react";
import ViewTipsModal from "../../ViewTipsModal/ViewTipsModal";
import NoTipsInfo from "../../ViewTipsModal/components/NoTipsInfo";

const PaymentTipsModal = () => {
  return (
    <>
      <ViewTipsModal />
      <NoTipsInfo method="wallet" />
    </>
  );
};

export default PaymentTipsModal;
